module.exports = "/static/js/355f8ac787f4e23168435049e472d174.png";